import { Button } from "component-library";
import { useTranslation } from "i18n";
import { useNavigate } from "react-router-dom";
import { GRAD_TRANSFER_FULL_PATH } from "config/common";

interface Props {
  enabled?: boolean;
}

const TransferToGrads = ({ enabled }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const buttonType = enabled ? "secondary" : "primary";

  return (
    <div className="mb-6 flex w-full flex-col gap-3 lg:w-[80%]">
      <div>
        <h3 className="text-xxl">
          {t(
            "performer:accountSettings.mySubscriptionPage.transferToGrad.title"
          )}
        </h3>
      </div>
      <span className="whitespace-pre-line">
        {t(
          "performer:accountSettings.mySubscriptionPage.transferToGrad.description"
        )}
      </span>
      <Button
        type={buttonType}
        text={t(
          "performer:accountSettings.mySubscriptionPage.transferToGrad.buttonTitle"
        )}
        className="w-fit"
        disabled={!enabled}
        size="small"
        onClick={() => navigate(GRAD_TRANSFER_FULL_PATH)}
      />
    </div>
  );
};

export default TransferToGrads;
